export default "__VITE_ASSET__DcvWg3ed__"